import {type ReactNode, useContext, useLayoutEffect} from "react";
import {InitialLoadContext} from "./InitialLoadContext.ts";

/** Mount only after all initial data and assets are available. */
export default function InitialLoadReady({children}: {children: ReactNode}) {
    const ready = useContext(InitialLoadContext);
    if (!ready) throw new Error("InitialLoadReady requires an InitialLoadBoundary");
    useLayoutEffect(ready, [ready]);
    return children;
}
